import { useState } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import { H2 } from 'UIComponents/elements/headings';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UIMatchTextArea from 'UIComponents/input/UIMatchTextArea';
import { getContentTypeId, getModalLangKey } from 'ContentEditorUI/utils/contentManagementPanel/contentTableUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DeleteContentModal = ({
  closeModal,
  content,
  deleteContent = () => {}
}) => {
  const [matchText, setMatchText] = useState('');
  const deleteMatchText = I18n.text('contentManagementPanel.modals.shared.delete.deleteMatchText');
  const contentTypeId = getContentTypeId(content);
  return /*#__PURE__*/_jsxs(UIModal, {
    "data-test-id": "delete-content-modal",
    use: "danger",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getModalLangKey('delete.header', contentTypeId)
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: closeModal
      })]
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "contentManagementPanel.modals.shared.delete.body",
        options: {
          name: content.name
        }
      }), /*#__PURE__*/_jsxs("div", {
        className: "m-top-6",
        children: [/*#__PURE__*/_jsx(UIFormLabel, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: getModalLangKey('delete.deleteMatchLabel', contentTypeId),
            options: {
              deleteMatchText
            }
          })
        }), /*#__PURE__*/_jsx(UIMatchTextArea, {
          "data-test-id": "delete-match-text-input",
          match: deleteMatchText,
          onChange: e => setMatchText(e.target.value)
        })]
      })]
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "modal-confirm",
        disabled: matchText !== deleteMatchText,
        onClick: () => deleteContent(content),
        use: "danger",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "contentManagementPanel.modals.shared.delete.confirm"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "modal-cancel",
        onClick: closeModal,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "contentManagementPanel.modals.shared.cancel"
        })
      })]
    })]
  });
};
export default DeleteContentModal;